<template>
  <div class="page">
    <home-header activeIndex="0" pageTitle="首页" :breadNav="false" />
    <div class="homeWrap">
      <div class="card" v-if="signUpShow && signUpShow.length != 0">
        <div class="cardTitle">
          单招报名确认
          <!-- <div class="more" @click="toMore('/singUp')">更多<a-icon class="right" type="right" /></div> -->
        </div>
        <div class="confirm" v-if="signUpFlag">
          <div v-for="(item, idx) in menuList" :key="idx">
            <div class="item" v-if="item.enable == 1" @click="goMenu(item)">
              <div class="left">
                <div class="icon">
                  <img
                    v-if="item.tFlag == 'baseInfo'"
                    :src="require('@/assets/home/icon1.png')"
                    alt=""
                  />
                  <img
                    v-if="item.tFlag == 'fileXz'"
                    :src="require('@/assets/home/icon2.png')"
                    alt=""
                  />
                  <img
                    v-if="item.tFlag == 'upload'"
                    :src="require('@/assets/home/icon3.png')"
                    alt=""
                  />
                  <img
                    v-if="item.tFlag == 'lastUpload'"
                    :src="require('@/assets/home/icon4.png')"
                    alt=""
                  />
                </div>
                <div class="info">
                  <div class="name">{{ item.tName }}</div>
                  <div class="desc" :title="item.tExplain">
                    {{ item.tExplain }}
                  </div>
                </div>
              </div>
              <div class="right">
                <img :src="require('@/assets/home/right-circle.png')" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="noData" v-else>
          <img :src="require('@/assets/home/no.png')" alt="" />
          <div class="word">暂未开放</div>
        </div>
      </div>
      <div class="card" v-if="signUpQueryShow && signUpQueryShow.length != 0">
        <div class="cardTitle">
          报名查看
          <!-- <div class="more" @click="toMore('/singUpLook')">更多<a-icon class="right" type="right" /></div> -->
        </div>
        <div class="lookUp" v-if="signUpLookFlag">
          <!-- 报名结果 -->
          <div class="model" v-if="flagSignUpResults">
            <div class="modelTitle">
              <img :src="require('@/assets/home/icon5.png')" alt="" />
              报名结果
            </div>
            <div>
              <div
                class="inner"
                v-if="status == '4' || status == '6' || status == '7'"
              >
                <div class="icon">
                  <img :src="require('@/assets/home/green.png')" alt="" />
                </div>
                <div class="tit">恭喜您！您的报名申请已通过审核</div>
                <div class="desc" v-if="sRemark">{{ sRemark }}</div>
                <div class="lookDetail" @click="toMore('/singUpLook')">
                  查看详情<a-icon class="right" type="right" />
                </div>
              </div>
              <div class="inner" v-if="status == '5'">
                <div class="icon">
                  <img :src="require('@/assets/home/yellow.png')" alt="" />
                </div>
                <div class="tit" v-if="flagReturnUpdate">
                  您的报名已退回，请<span @click="toMore('/singUp')"
                    >修改填报信息</span
                  >后重新提交报名
                </div>
                <div class="tit" v-else>您的报名已退回</div>
                <div class="desc" v-if="sRemark">{{ sRemark }}</div>
              </div>
              <div class="noData" v-if="status == '0' || status == '1'">
                <img :src="require('@/assets/home/no.png')" alt="" />
                <div class="word">您未填写报名信息</div>
              </div>
              <div class="noData" v-if="status == '2'">
                <img :src="require('@/assets/home/no.png')" alt="" />
                <div class="word">您未进行资料回传</div>
              </div>
              <div class="noData" v-if="status == '3'">
                <img :src="require('@/assets/home/no.png')" alt="" />
                <div class="word">审核中，暂无结果</div>
              </div>
            </div>
            <div class="noData" v-if="!status">
              <img :src="require('@/assets/home/no.png')" alt="" />
              <div class="word">暂无结果</div>
            </div>
          </div>
          <!-- 成绩查询 -->
          <div class="model scoreBox" v-if="flagScore">
            <div class="modelTitle">
              <img :src="require('@/assets/home/icon6.png')" alt="" />
              成绩查询
            </div>
            <div class="inner" v-if="scoreList.length!=0||totalScore!=0||scoreTotalZb!=0">
              <div v-if="totalScoreShow == 1 || zbToalScoreShow == 1">
                <div class="label">您的总分</div>
                <div class="score">
                  <span v-if="totalScoreShow == 1"> {{ formatScore(totalScore, totalScoreFormat) }}</span>
                  <span v-if="zbToalScoreShow == 1 && totalScoreShow == 1">
                    /
                  </span>
                  <span v-if="zbToalScoreShow == 1">
                    {{ formatScore(scoreTotalZb, zbToalScoreFormat) }}
                    <span style="font-size: 20px">（{{ zbToalScoreBm != "" ? zbToalScoreBm : "占比分" }}）</span>
                    <!-- <span style="font-size: 20px">(占分比)</span> -->
                  </span>
                </div>
              </div>
              <!-- 科目 -->
              <div
                v-if="
                  totalScoreShow !== 1 &&
                  zbToalScoreShow !== 1 &&
                  (subjectSocreShow == 1 || zbSubjectScoreShow == 1)
                "
              >
                <div
                  class="itemScore"
                  v-for="(item, index) in scoreList"
                  :key="index"
                >
                  <div>
                    {{ item.eSubject
                    }}<span v-if="item.tagScoreZb && subjectZbScoreShow == 1"
                      >（{{ item.tagScoreZb }}%）</span
                    >
                  </div>

                  <div class="dashed"></div>
                  <div style="display: flex">
                    <span v-if="subjectSocreShow == 1">{{ item.esScore }}</span>
                    <span
                      v-if="zbSubjectScoreShow == 1 && subjectSocreShow == 1"
                    >
                      /</span
                    >
                    <span v-if="zbSubjectScoreShow == 1"
                      >{{ formatScore(item.zbScore, zbSubjectScoreFormat) }} (占比分)</span
                    >

                    <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span>{{ item.bz }}</span>
                      </template>
                      <div
                        class="tip"
                        v-if="subjectSorecDescShow == 1 && item.bz"
                      >
                        备注
                      </div>
                    </a-tooltip>
                  </div>
                </div>
              </div>
              <!-- 科目 -->
              <div
                v-if="
                  subjectSocreShow == 1 ||
                  zbSubjectScoreShow == 1 ||
                  totalScoreShow == 1 ||
                  zbToalScoreShow == 1
                "
                class="lookDetail"
                @click="toMore('/singUpLook')"
              >
                查看详情<a-icon class="right" type="right" />
              </div>
            </div>
            <!-- <div
              class="noData"
              v-if="
                subjectSocreShow !== 1 &&
                zbSubjectScoreShow !== 1 &&
                totalScoreShow !== 1 &&
                zbToalScoreShow !== 1
              "
            > -->
            <div v-else>
              <img :src="require('@/assets/home/no.png')" alt="" />
              <div class="word">暂无数据</div>
            </div>
          </div>
          <!-- 录取结果 -->
          <div class="model result" v-if="lqFlag">
            <div class="modelTitle">
              <img :src="require('@/assets/home/icon7.png')" alt="" />
              录取结果
              <span class="arrivalLink" v-if="showArrivalIntentEntry" @click="toArrivalIntent">报到意向确认</span>
            </div>
            <div v-if="lqFlag">
              <div class="inner" v-if="status == '6'">
                <div class="title" v-if="lqtips">{{ lqtips }}</div>
                <div class="title" v-else>
                  恭喜您！您已被我校预录取（正式录取以招办下发的录取数据为准），请等待录取通知书的发放以及后续学习的安排。
                </div>
                <div class="desc" v-if="lqRemark">{{ lqRemark }}</div>
                <div class="lookDetail" @click="toMore('/singUpLook')">
                  查看详情<a-icon class="right" type="right" />
                </div>
              </div>
              <div class="inner" v-else-if="status == '7'">
                <div class="title" v-if="lqtips">{{ lqtips }}</div>
                <div class="title" v-else>抱歉！您未被我校录取。</div>
                <div class="desc" v-if="lqRemark">{{ lqRemark }}</div>
              </div>
              <div class="inner" v-else>
                <div class="title">
                  招生工作正在进行中，还未公布预录取结果。
                </div>
              </div>
            </div>
            <div class="noData" v-else>
              <img :src="require('@/assets/home/no.png')" alt="" />
              <div class="word">暂无结果</div>
            </div>
          </div>
          <div class="model scoreBox" style="background: transparent;" v-if="!flagScore || !lqFlag || !flagSignUpResults">
          </div>
        </div>
        <div class="noData" v-else>
          <img :src="require('@/assets/home/no.png')" alt="" />
          <div class="word">暂未开放</div>
        </div>
      </div>
      <div class="noticeWrap">
        <div class="card" v-if="noticeShow && noticeShow.length != 0">
          <div class="cardTitle">
            通知公告
            <div class="more" @click="toMore('/notice')">
              更多<a-icon class="right" type="right" />
            </div>
          </div>
          <div class="notice">
            <div
              class="item"
              v-for="(item, idx) in noticeList"
              :key="idx"
              @click="toNoticeDetail(item.id)"
            >
              <div class="con">
                <img
                  class="icon"
                  :src="require('@/assets/home/notice.png')"
                  alt=""
                />
                <div class="title">{{ item.nTitle }}</div>
              </div>
              <div class="time">{{ item.nCtime | dateFilter }}</div>
            </div>
            <div class="noData" v-if="noticeList.length == 0">
              <img :src="require('@/assets/home/no.png')" alt="" />
              <div class="word">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="card" v-if="qaShow && qaShow.length != 0">
          <div class="cardTitle">
            校园Q&A
            <div class="more" @click="toMore('/qa')">
              更多<a-icon class="right" type="right" />
            </div>
          </div>
          <div class="notice">
            <div
              class="item"
              v-for="(item, idx) in qaList"
              :key="idx"
              @click="toQADetail(item)"
            >
              <div class="con">
                <img
                  class="icon"
                  :src="require('@/assets/home/qa.png')"
                  alt=""
                />
                <div class="title">{{ item.qaQuestions }}</div>
              </div>
            </div>
            <div class="noData" v-if="qaList.length == 0">
              <img :src="require('@/assets/home/no.png')" alt="" />
              <div class="word">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <div class="mask" v-if="list.length && isShow">
      <div class="content">
        <div class="top">
          <div class="title">{{ detail.nTitle }}</div>
          <div class="department">
            <span>{{ detail.nSource }}</span>
            <span>{{ detail.nCtime | dateFilter }}</span>
          </div>
          <div
            style="color: black; font-size: 18px"
            v-html="detail.nContent"
          ></div>
        </div>

        <div v-if="currentIndex !== total" class="buttom" @click="nextStep">
          下一条({{ currentIndex }}/{{ total }})
        </div>
        <div v-else class="buttom" @click="isShow = false">
          关闭({{ currentIndex }}/{{ total }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getInfoType, getStatus } from "@/api/form";
import { queryStatu, GradeDetail } from "@/api/look";
import { getFlag } from "@/api/common";
import { getNoticeList, getQAList, getForcedReadingList } from "@/api/notice";
import { getNoticeDetail } from "@/api/notice";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";
import { formatScore } from "@/utils/scoreFormat";

export default {
  name: "Home",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      signUpShow: false,
      signUpQueryShow: false,
      noticeShow: false,
      qaShow: false,
      signUpList: ["signUp"],
      signUpQueryLsit: ["signUpQuery"],
      noticeList1: ["notice"],
      qaList1: ["qa"],
      isShow: true,
      menuList: [],
      noticeList: [],
      qaList: [],
      signUpFlag: false, // 报名
      signUpLookFlag: false, // 报名查看
      flagSignUpResults: false, // 报名结果
      flagScore: false, // 成绩
      flagDownload: false, // 证件下载
      lqFlag: false, // 录取结果
      flagReturnUpdate: false, // 退回是否可修改
      scoreList: [],
      totalScore: "", // 总分
      scoreTotalZb: "", //占比总分
      lqtips: "", // 录取提示语
      lqzy: "",
      status: "", // 学生报名状态( 0 信息导入 1 注册账号 2 信息确认，3 待审核，4通过， 5 退回  6 已录取，7 未录取)
      sRemark: "",
      lqRemark: "",
      msStatus: "", // 面试资料审核状态 1 待审核  2 通过 3退回 4 不通过
      msRemark: "", // 面试资料审核备注
      flag: "",
      detail: {},
      total: "",
      currentIndex: 1,
      ids: "",
      list: [],

      lqScoreShow: "",
      totalScoreShow: "",
      zbToalScoreShow: "",
      subjectSocreShow: "",
      zbSubjectScoreShow: "",
      subjectZbScoreShow: "",
      subjectSorecDescShow: "",
      zbToalScoreBm:"",
      totalScoreFormat: "",
      zbToalScoreFormat: "",
      zbSubjectScoreFormat: "",
      hasArrivalIntentAuth: false,
      showArrivalIntentEntry: false,
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format("YYYY-MM-DD");
    },
  },
  methods: {
    formatScore,
    nextStep() {
      let nextId = this.ids[this.currentIndex];
      this.currentIndex++;
      getNoticeDetail({
        id: nextId,
      }).then((res) => {
        this.detail = res;
      });
    },
    toMore(url) {
      this.$router.push({
        path: url,
      });
    },
    toArrivalIntent() {
      this.$router.push({
        path: "/arrivalIntent",
      });
    },
    initArrivalIntentAuth() {
      const userInfo = JSON.parse(localStorage.getItem("user"));
      let hasAuth = false;
      if (userInfo && userInfo.menuList) {
        userInfo.menuList.forEach((menu) => {
          if (menu.mcode === "arrivalIntent") {
            hasAuth = true;
          }
        });
      }
      this.hasArrivalIntentAuth = hasAuth;
      this.showArrivalIntentEntry = this.hasArrivalIntentAuth && String(this.status) === "6";
    },
    // QA
    toQADetail(item) {
      this.$router.push({
        path: "/qaDetail",
        query: {
          item: item,
        },
      });
    },
    getQA(page) {
      getQAList({
        uvCode: localStorage.getItem("uvCode"),
        page: 1,
        size: 4,
      }).then((res) => {
        this.qaList = res.rows;
      });
    },
    // 通知公告
    toNoticeDetail(id) {
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: id,
        },
      });
    },
    getNotice(page) {
      getNoticeList({
        uvCode: localStorage.getItem("uvCode"),
        page: 1,
        size: 4,
      }).then((res) => {
        this.noticeList = res.rows;
      });
    },
    getForcedReading() {
      getForcedReadingList({
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        this.total = res.length;
        this.list = res;
        this.ids = this.list.map((item) => item.id);
        getNoticeDetail({
          id: this.list[0].id,
        }).then((res) => {
          this.detail = res;
        });
      });
    },
    // 获取报名确认菜单
    getInfoType() {
      getInfoType().then((res) => {
        this.menuList = res;
      });
    },
    getStatus() {
      let userInfo = JSON.parse(localStorage.getItem("user"));
      let sid = "";
      if (userInfo) {
        sid = userInfo.sid;
      }
      getStatus({
        sId: sid,
      }).then((res) => {
        this.flag = res;
      });
    },
    goMenu(item) {
      localStorage.setItem("TypeId", item.id);
      if (item.tFlag == "baseInfo") {
        console.log(item, "129219219");
        this.$router.push({
          path: "/singUp",
          query: {
            curTab: 4,
            tjStatus: item.tjStatus,
          },
        });
      }
      // 下载
      if (item.tFlag == "fileXz") {
        if (this.flag >= 2) {
          this.$router.push({
            path: "/singUp",
            query: {
              curTab: 1,
            },
          });
        } else {
          this.$message.info("请先进行信息核对");
        }
      }
      // 证明材料上传
      if (item.tFlag == "upload") {
        console.log(item, "219219219");
        if (this.flag == 0 || this.flag == 1) {
          this.$message.info("请先进行信息核对");
        } else {
          this.$router.push({
            path: "/singUp",
            query: {
              curTab: 2,
              tjStatus: item.tjStatus,
            },
          });
        }
      }
      // 获奖资料等上传
      if (item.tFlag == "lastUpload") {
        this.$router.push({
          path: "/singUp",
          query: {
            curTab: 3,
            tjStatus: item.tjStatus,
          },
        });
      }
    },
    getFlagAll() {
      // 报名---大块
      getFlag({
        paramKey: "signup2",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        if (res.paramStatus == "1") {
          this.signUpFlag = true;
          this.getInfoType();
          this.getStatus();
        } else {
          this.signUpFlag = false;
        }
      });
      // 报名查看---大块
      getFlag({
        paramKey: "signupLook2",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        console.log(111);

        if (res.paramStatus == "1") {
          this.signUpLookFlag = true;
          this.getLookFlag();
          this.queryStatu();
        } else {
          this.signUpLookFlag = false;
        }
      });
    },
    queryStatu() {
      queryStatu({
        scode: localStorage.getItem("sCode"),
      }).then((res) => {
        if (res.data) {
          if (res.data.recruit) {
            this.status = res.data.recruit.sStatus;
            this.sRemark = res.data.recruit.sRemark;
            this.msStatus = res.data.recruit.msStatus;
            this.msRemark = res.data.recruit.msRemark;
            this.lqRemark = res.data.recruit.lqRemark;
          }

          this.scoreList = res.data.stuScores;
          this.lqzy = res.data.lqzy;
          this.lqtips = res.data.lqtips;
          this.totalScore = res.data.scoreTotal;
          this.scoreTotalZb = res.data.scoreTotalZb;
          this.lqFlag = res.data.lqFlag;
          this.flagScore = res.data.scoreFlag;
          this.showArrivalIntentEntry = this.hasArrivalIntentAuth && String(this.status) === "6";
        }
      });
    },
    getLookFlag() {
      // 报名结果
      getFlag({
        paramKey: "signUpResults",
        uvCode: localStorage.getItem('uvCode')
      }).then(res => {
        if (res.paramValue == '1') {
          this.flagSignUpResults = true;
        } else {
          this.flagSignUpResults = false;
        }
      })
      // 证件下载
      // getFlag({
      //   paramKey: "download",
      //   uvCode: localStorage.getItem('uvCode')
      // }).then(res => {
      //   if (res.paramValue == '1') {
      //     this.flagDownload = true;
      //   } else {
      //     this.flagDownload = false;
      //   }
      // })
      // 成绩查询
      getFlag({
        paramKey: "score",
        uvCode: localStorage.getItem('uvCode')
      }).then(res => {
        if (res.paramValue == '1') {
          this.flagScore = true;
        } else {
          this.flagScore = false;
        }
      })
      // 录取结果
      getFlag({
        paramKey: "acceptanceResults",
        uvCode: localStorage.getItem('uvCode')
      }).then(res => {
        if (res.paramValue == '1') {
          this.lqFlag = true;
        } else {
          this.lqFlag = false;
        }
      })
      // 退回是否可修改
      getFlag({
        paramKey: "returnUpdate",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        if (res.paramStatus == "1") {
          this.flagReturnUpdate = true;
        } else {
          this.flagReturnUpdate = false;
        }
      });
    },
    getmenuShow() {},
  },
  created() {},
  mounted() {
    this.initArrivalIntentAuth();
    this.getFlagAll();
    this.getNotice();
    this.getQA();
    this.getForcedReading();
    GradeDetail().then((res) => {
      this.lqScoreShow = res.lqScoreShow;
      this.totalScoreShow = res.totalScoreShow;
      this.totalScoreFormat = res.totalScoreFormat || "5";
      this.zbToalScoreShow = res.zbToalScoreShow;
      this.zbToalScoreFormat = res.zbToalScoreFormat || "5";
      this.subjectSocreShow = res.subjectSocreShow;
      this.zbSubjectScoreShow = res.zbSubjectScoreShow;
      this.zbSubjectScoreFormat = res.zbSubjectScoreFormat || "5";
      this.subjectZbScoreShow = res.subjectZbScoreShow;
      this.subjectSorecDescShow = res.subjectSorecDescShow;
      this.zbToalScoreBm = res.zbToalScoreBm || "";
    });

    let userInfo = JSON.parse(localStorage.getItem("user"));

    this.signUpShow = userInfo.menuList.filter((ele) => {
      return this.signUpList.includes(ele.mcode);
    });
    this.signUpQueryShow = userInfo.menuList.filter((ele) => {
      return this.signUpQueryLsit.includes(ele.mcode);
    });
    this.noticeShow = userInfo.menuList.filter((ele) => {
      return this.noticeList1.includes(ele.mcode);
    });
    this.qaShow = userInfo.menuList.filter((ele) => {
      return this.qaList1.includes(ele.mcode);
    });

    // // 判断是否是登录
    // const firstLogin = localStorage.getItem("firstLogin");
    // if (firstLogin === "true") {
    //   this.isShow = true;
    // } else {
    //   this.isShow = false;
    // }
    // localStorage.setItem("firstLogin", false);
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.homeWrap {
  width: 1200px;
  min-height: 448px;
  margin: 20px auto 30px;
  .card {
    background-color: #ffffff;
    border-radius: 6px;
    margin-bottom: 20px;
  }
  .cardTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #e7e7e7;
    padding: 13px 24px;
    .more {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      font-weight: normal;
      .right {
        font-size: 12px;
        margin-left: 4px;
      }
      &:hover {
        color: #2a79ff;
      }
    }
  }
  .noData {
    margin: 0 auto;
    padding: 40px 0;
    text-align: center;
    .word {
      font-size: 12px;
      color: #999;
      margin-top: 8px;
    }
  }
  .confirm {
    padding: 20px 24px;
    display: flex;
    // justify-content: space-between;
    .item {
      width: 276px;
      height: 76px;
      background: #fafafa;
      border-radius: 4px;
      padding: 14px 16px 14px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      margin-right: 10px;
      .left {
        display: flex;
        align-items: center;
      }
      .icon {
        width: 36px;
        height: 36px;
      }
      .info {
        margin-left: 16px;
        width: 160px;
      }
      .name {
        font-size: 16px;
        color: #333;
        font-weight: 600;
      }
      .desc {
        font-size: 14px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .noticeWrap {
    display: flex;
    justify-content: space-between;
    .card {
      width: 590px;
    }
    .notice {
      padding: 0 20px 0 24px;
      min-height: 225px;
      .item {
        border-bottom: 1px solid #eaeaea;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 56px;
        &:last-child {
          border: 0;
        }
      }
      .con {
        display: flex;
        align-items: center;
      }
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      .title {
        font-size: 16px;
        color: #333333;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 440px;
      }
      .time {
        font-size: 14px;
        color: #999;
      }
    }
  }
  .lookUp {
    padding: 18px 24px 22px;
    display: flex;
    justify-content: space-between;
    .model {
      width: 373px;
      height: 204px;
      background: #fafafa;
      border-radius: 4px;
      padding: 16px 16px 12px;
      text-align: center;
      position: relative;
      .modelTitle {
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
        text-align: left;
        display: flex;
        align-items: center;
        font-weight: 600;
        img {
          margin-right: 6px;
        }
        .arrivalLink {
          margin-left: auto;
          color: #2a79ff;
          cursor: pointer;
          font-weight: normal;
          font-size: 13px;
        }
      }
      .lookDetail {
        width: 80px;
        font-size: 14px;
        color: #2a79ff;
        cursor: pointer;
        position: absolute;
        bottom: 12px;
        left: 50%;
        margin-left: -40px;
        .right {
          font-size: 12px;
          margin-left: 4px;
        }
      }
      .noData {
        margin: 0 auto;
        padding: 2px 0 0;
        .word {
          font-size: 12px;
          color: #999;
          margin-top: 0px;
        }
      }
    }
    .tit {
      font-size: 14px;
      color: #333333;
      margin: 8px 0 4px;
      font-weight: 600;
      span {
        color: #2a79ff;
        text-decoration: underline;
      }
    }
    .desc {
      font-size: 12px;
      color: #999;
    }
    .scoreBox {
      .label {
        font-size: 16px;
        color: #666;
        margin: 20px auto 4px;
      }
      .score {
        font-weight: 700;
        font-size: 30px;
        color: #333333;
      }
    }
    .result {
      text-align: left;
      .title {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        padding: 8px 0 4px;
        text-indent: 2em;
      }
      .desc {
        font-size: 12px;
        color: #999;
        // text-indent: 2em;
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999; /* 设置遮罩层的z-index值为9999 */
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 60%;
    height: 80%;
    background: #f5fbfa;
    border-radius: 2%;
    .top {
      width: 88%;
      height: 90%;
      margin: 0 auto;
      overflow: auto;
      overflow-x: hidden;
      .title {
        text-align: center;
        font-weight: 700;
        padding: 30px 0 20px;
        color: black;
        font-size: 18px;
      }
      .department {
        display: flex;
        justify-content: space-between;
        color: black;
        font-size: 18px;
        padding: 0 0 30px;
      }
    }
    .buttom {
      width: 20%;
      height: 8%;
      background: #2a79ff;
      border-radius: 20px;
      margin: 0 auto;
      color: #fff;
      text-align: center;
      line-height: 48px;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
.itemScore {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
  color: #666;
  font-size: 14px;
  span {
    color: #999;
  }
  .dashed {
    flex-grow: 1;
    border-top: 1px dashed #d6d6d6;
    margin: 0 8px;
  }
}
.tip {
  color: #ff5252;
  font-size: 14px;
}
</style>
